import {BearerTokenFetchClient, IFetchOptions, isUrlAbsolute} from '@pnp/common';

import {AuthenticationParameters, UserAgentApplication} from 'msal';
import store from '@/store'

export class PnPFetchClient extends BearerTokenFetchClient {
    constructor(private authContext: UserAgentApplication) {
        super(null);
    }

    public async fetch(url: string, options: IFetchOptions = {}): Promise<Response> {
        if (!isUrlAbsolute(url)) {
            throw new Error('You must supply absolute urls to PnPFetchClient.fetch.');
        }

        this.token = await this.getToken(this.getResource(url));
        return super.fetch(url, options);
    }

    private async getToken(resource: string): Promise<string> {

        const request: AuthenticationParameters = {};

        try {
            let response;
            if (resource.indexOf('sharepoint') !== -1) {
                request.scopes = [
                    `${resource}/AllSites.Manage`,
                    `${resource}/MyFiles.Write`,
                ];
                response = await this.authContext.acquireTokenSilent(request);
                store.commit('updateSpToken', response.accessToken);
            } else if (resource.indexOf('graph') !== -1) {
                request.scopes = [
                    `${resource}/Channel.ReadBasic.All`,
                    `${resource}/User.Read`,
                    `${resource}/profile`,
                    `${resource}/Team.ReadBasic.All`,
                    `${resource}/Files.ReadWrite.All`,
                ]
                response = await this.authContext.acquireTokenSilent(request);
                store.commit('updateGraphToken', response.accessToken);
            }

            return response.accessToken;
        } catch (error) {
            if (this.requiresInteraction(error.errorCode)) {
                this.authContext.acquireTokenRedirect(request);
            } else {
                throw error;
            }
        }
    }

    private requiresInteraction(errorCode: string) {
        if (!errorCode || !errorCode.length) {
            return false;
        }
        return errorCode === "consent_required" ||
            errorCode === "interaction_required" ||
            errorCode === "login_required";
    }

    private getResource(url: string): string {
        const parser = document.createElement('a') as HTMLAnchorElement;
        parser.href = url;
        return `${parser.protocol}//${parser.hostname}`;
    }
}
